<script lang="ts">
  import Heading from "../../components/atoms/Heading.svelte";
  import type { Product, AvaliableProducts } from "../../helpers/types";
  import usePurchaseModule from "../../providers/usePurchaseModule";
  import ProductPrices from "../../components/organisms/ProductPrices.svelte";

  interface Props {
    location: string;
    productOrder: string[];
  }

  let { location, productOrder }: Props = $props();

  const { state: store, send } = usePurchaseModule();
  let avaliableProducts: AvaliableProducts = $state({});
  let selectedProductId = $state($store.context.selectedProductId);
  let selectedProduct: Product | undefined = $state();
  let showSelectProductError = $state(false);

  const onClickContinue = (e: Event) => {
    e.preventDefault();
    if (!selectedProduct) {
      const allProducts = [
        ...(avaliableProducts.fixedProducts ?? []),
        ...(avaliableProducts.variableProducts ?? []),
        ...(avaliableProducts.hourlyProducts ?? []),
      ];

      if (allProducts.length === 1) {
        selectedProduct = allProducts[0];
        selectedProductId = selectedProduct.id;
      }
    }

    if (!selectedProduct) {
      showSelectProductError = true;
      return;
    }
    
    send("SET_PRODUCT_TYPE", { productType: selectedProduct.type });
    send("SET_START_DATES", { startDates: selectedProduct.startDates });
    send("SET_PRODUCT_ID", { selectedProductId: selectedProduct.id });
    window.location.href = location;
  };

  const removeSelectedProductId = () => {
    send("SET_PRODUCT_ID", { selectedProductId: undefined });
  };
</script>

<ProductPrices
  {productOrder}
  estimation={$store.context.estimation}
  bind:avaliableProducts
  bind:showSelectProductError
  bind:selectedProductId
  bind:selectedProduct
  zipcode={$store.context.facilityInformation.zipcode}
  campaign={$store.context.campaign}
  {removeSelectedProductId}
  goBack={() => send("BACK")}
  {onClickContinue}
>
  <Heading class="text-Neutral900" variant="primary">Vilken typ av elpris vill du ha?</Heading>
</ProductPrices>
